import { IHistory } from '../../../common/api/services/HistoryApi/types/historyTypes';

export interface IHistoryState {
    total: Record<string, number>;
    historyFields: Record<string, Array<Record<string, unknown>>>;
    activeFields: Record<string, Array<Record<string, unknown>>>;
    errorMessages: Array<{ message: string; property: string }>;
    activeKeys: Array<string>;
}

export enum ShownTypes {
    select = 'select',
    date = 'date',
    input = 'input',
    checkbox = 'checkbox',
    radio = 'radio',
    switch = 'switch',
    label = 'label',
    uploadFile = 'uploadFile',
}
